export const icPresetOptions = new Map([
  [
    'psmp-original',
    { label: 'Первичная медико-санитарная помощь - Оригинальная статья', value: 'psmp-original' },
  ],
  [
    'psmp-litreview',
    { label: 'Первичная медико-санитарная помощь - Литературный обзор', value: 'psmp-litreview' },
  ],
  [
    'psmp-clinicalcase',
    { label: 'Первичная медико-санитарная помощь - Клинический случай', value: 'psmp-clinicalcase' },
  ],
  [
    'kvtp-original',
    { label: 'Кардиоваскулярная терапия и профилактика - Оригинальная статья', value: 'kvtp-original' }
  ],
  [
    'kvtp-clinicalcase',
    { label: 'Кардиоваскулярная терапия и профилактика - Клинический случай', value: 'kvtp-clinicalcase' }
  ],
  [
    'kvtp-litreview',
    { label: 'Кардиоваскулярная терапия и профилактика - Литературный обзор', value: 'kvtp-litreview' },
  ],
  [
    'rcj-original',
    { label: 'Российский кардиологический журнал - Оригинальная статья', value: 'rcj-original' },
  ],
  [
    'rcj-litreview',
    { label: 'Российский кардиологический журнал - Литературный обзор', value: 'rcj-litreview' },
  ],
  [
    'profmed-original',
    { label: 'Профилактическая медицина - Оригинальная статья', value: 'profmed-original' }
  ]
])


